"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactIntersectionObserver = require("react-intersection-observer");

var _reactlytics = require("reactlytics");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var OnVisible = function OnVisible(_ref) {
  var shouldForwardRef = _ref.shouldForwardRef,
      children = _ref.children,
      analyticsInfo = _ref.analyticsInfo,
      inViewOptions = _ref.inViewOptions,
      onView = _ref.onView;
  (0, _react.useEffect)(function () {
    // Polyfill for IE11
    // istanbul ignore if
    if (typeof window.IntersectionObserver === 'undefined') {
      // eslint-disable-next-line global-require
      require('intersection-observer');
    }
  }, []);

  var _useInView = (0, _reactIntersectionObserver.useInView)(_objectSpread({
    threshold: 0.3,
    triggerOnce: true
  }, inViewOptions)),
      inView = _useInView.inView,
      ref = _useInView.ref;

  var _useReactlytics = (0, _reactlytics.useReactlytics)(),
      track = _useReactlytics.track;

  (0, _react.useEffect)(function () {
    if (inView) {
      onView();
      track({
        event: _objectSpread({
          type: 'impression'
        }, analyticsInfo)
      });
    }
  }, [inView]);

  if (shouldForwardRef) {
    var child; // Only supply forwarded ref on a single valid child element.

    try {
      child = _react.default.Children.only(children);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('shouldForwardRef can only be used if a single child is in OnVisible');
    }
    /* istanbul ignore next */


    if ( /*#__PURE__*/_react.default.isValidElement(child)) {
      return /*#__PURE__*/_react.default.createElement(child.type, _objectSpread(_objectSpread({}, child.props), {}, {
        onVisibleRef: ref
      }));
    }
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref
  }, children);
};

OnVisible.propTypes = {
  children: _propTypes.node.isRequired,
  shouldForwardRef: _propTypes.bool,
  analyticsInfo: (0, _propTypes.shape)({
    element: _propTypes.string
  }).isRequired,
  inViewOptions: (0, _propTypes.shape)({}),
  onView: _propTypes.func
};
OnVisible.defaultProps = {
  shouldForwardRef: false,
  inViewOptions: {},
  onView: function onView() {}
};
var _default = OnVisible;
exports.default = _default;